export default __webpack_public_path__ + "static/media/mid4.3e18bf75.jpg";